import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Login = () => {
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState(""); 
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); // Make sure this is called to prevent default form submission
    console.log("Form submitted:", { email, password });

    try {
      setError("");
      setLoading(true);

      if (email && password) {
        console.log("Making API call...");

        // Direct approach without axios to rule out axios issues
        const response = await fetch(
          "https://zniieycmcw.ap-south-1.awsapprunner.com/login",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: email,
              password: password,
            }),
          }
        );

        const data = await response.json();
        console.log("API response:", data);

        if (data.access_token) {
          console.log("Token received:", data.access_token);
          const success = login({
            email,
            access_token: data.access_token,
          });

          console.log("Login successful, redirecting...");
          navigate("/");
        } else {
          setError("Invalid response from server");
        }
      } else {
        setError("Please enter both username and password");
      }
    } catch (error) {
      console.error("Login error full details:", error);
      setError("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="logo">
            <img src="AadrilaLogo.png" alt="LOGO" width={250} />
          </div>
          <h1>Auto Insurance</h1>
          <p>Sign in to access your insurance portal</p>
        </div>

        {error && (
          <div className="error-message">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                stroke="#dc2626"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 8V12"
                stroke="#dc2626"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 16H12.01"
                stroke="#dc2626"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{error}</span>
          </div>
        )}

        <form id="loginForm" onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Username</label>
            <div className="input-wrapper">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                  stroke="#64748b"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  cx="12"
                  cy="7"
                  r="4"
                  stroke="#64748b"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <input
                type="text"
                id="email"
                placeholder="Username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="3"
                  y="11"
                  width="18"
                  height="11"
                  rx="2"
                  stroke="#64748b"
                  strokeWidth="2"
                />
                <path
                  d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                  stroke="#64748b"
                  strokeWidth="2"
                />
              </svg>
              <input
                type="password"
                id="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Use a regular button instead of the custom Button component for testing */}
          <button
            type="submit"
            style={{
              width: "100%",
              marginTop: "24px",
              backgroundColor: "#2563eb",
              color: "white",
              padding: "12px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "600",
              boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.3)",
              transition: "all 0.2s ease",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
            }}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>

        </form>

        <p className="signup-prompt">
          Don't have an account?{" "}
          <a href="mailto:support@aadrila.com">Contact support</a>
        </p>
      </div>

      {/* Existing styles */}
      <style>{`
        .login-page {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          background: linear-gradient(120deg, #f0f5ff, #e6f0ff);
        }

        .login-container {
          background: white;
          padding: 2.5rem;
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
          width: 100%;
          max-width: 450px;
          transition: transform 0.3s ease;
        }

        .login-container:hover {
          transform: translateY(-5px);
        }

        .login-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .logo {
          margin: 0 auto 1rem;
        }

        .login-header h1 {
          margin: 0;
          color: #1e293b;
          font-size: 1.8rem;
          font-weight: 700;
        }

        .login-header p {
          color: #64748b;
          margin-top: 0.5rem;
          font-size: 1rem;
        }

        .error-message {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 12px;
          border-radius: 8px;
          background-color: #fee2e2;
          color: #b91c1c;
          margin-bottom: 1.5rem;
        }

        .form-group {
          margin-bottom: 1.25rem;
        }

        label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #334155;
          font-size: 0.95rem;
        }

        .input-wrapper {
          display: flex;
          align-items: center;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          padding: 0 12px;
          transition: all 0.2s ease;
        }

        .input-wrapper:focus-within {
          border-color: #2563eb;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
        }

        .input-wrapper svg {
          margin-right: 8px;
        }

        input {
          width: 100%;
          padding: 12px 0;
          border: none;
          outline: none;
          font-size: 1rem;
          color: #0f172a;
          background: transparent;
        }

        input::placeholder {
          color: #94a3b8;
        }

        .remember-forgot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 1rem;
        }

        .remember-me {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.9rem;
          color: #475569;
        }

        .forgot-password {
          font-size: 0.9rem;
          color: #2563eb;
          text-decoration: none;
        }

        .forgot-password:hover {
          text-decoration: underline;
        }

        .signup-prompt {
          text-align: center;
          margin-top: 2rem;
          font-size: 0.95rem;
          color: #475569;
        }

        .signup-prompt a {
          color: #2563eb;
          text-decoration: none;
          font-weight: 600;
        }

        .signup-prompt a:hover {
          text-decoration: underline;
        }

        @media (max-width: 520px) {
          .login-container {
            padding: 1.75rem;
            margin: 0 1rem;
            border-radius: 10px;
          }

          .login-header h1 {
            font-size: 1.5rem;
          }

          .remember-forgot {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default Login;
